export default __webpack_public_path__ + "static/media/wallet-coins.380be5a9.png";